import { formatDate } from '../../../lib/formatDate';
import { getImageUrl } from '../../../config';

// Nexus's own Google sign-in, pinned above the lists with the RTG logo. It is
// not a to-do (IT closes it by deactivating the Nexus account) and can't be
// disconnected from here, so it carries no checkbox and no buttons.
export default function NexusCard({ app, isMemberView }) {
  const date = app.access_given_at
    ? `Access given ${formatDate(app.access_given_at)}`
    : app.access_given_before ? `Linked before ${formatDate(app.access_given_before)}` : null;
  return (
    <aside className="ca-nexus" aria-label={isMemberView ? 'Nexus sign-in' : 'Your Nexus sign-in'}>
      <span className="ca-tile ca-tile--nexus" aria-hidden="true">
        <img className="ca-tile__img" src={getImageUrl('/images/rtg-logo-red.png')} alt="" width="32" height="32" />
      </span>
      <div className="ca-row__body">
        <span className="ca-row__name">{app.display_text}</span>
        <span className="ca-row__meta">Used to sign in to Nexus</span>
        {date && <span className="ca-row__meta">{date}</span>}
      </div>
    </aside>
  );
}
